import type { CreateResumeRoute } from './types';

export const createResumeRoutes: CreateResumeRoute[] = [
  'personal-details',
  'career-history',
  'education',
  'licences',
  'skills',
  'languages',
  'summary',
  'finish-resume',
];
